import {
  ENUM_STORAGES_LIST,
  ENUM_STORAGES_LIST_SUCCESS,
  ENUM_STORAGES_LIST_ERROR,
} from "./actionTypes"


export const enumStoragesList = data => ({
  type: ENUM_STORAGES_LIST,
  payload: data
});

export const enumStoragesListSuccess = data => ({
  type: ENUM_STORAGES_LIST_SUCCESS,
  payload: {data}
});

export const enumStoragesListError = error => ({
  type: ENUM_STORAGES_LIST_ERROR,
  payload: error,
});
